import Backdrop from "@mui/material/Backdrop";
import MuiDialog, { type DialogProps } from "@mui/material/Dialog";
import Fade from "@mui/material/Fade";
import type { TransitionProps } from "@mui/material/transitions";
import type { ComponentChildren, JSX } from "preact";
import { forwardRef } from "preact/compat";

const TRANSITION_TIMEOUT = 500;

type ScrollingDialogProps = {
  open: boolean;
  children: JSX.Element | Array<JSX.Element | boolean>;
  className?: string;
  scroll?: "body" | "paper";
  onClose?: (event: unknown, reason: "backdropClick" | "escapeKeyDown") => void;
  "aria-label"?: string;
  "aria-labelledby"?: string;
  "aria-description"?: string;
  "aria-describedby"?: string;
} & DialogProps;

type FadeTransitionProps = TransitionProps & { children?: ComponentChildren };

const FadeTransition = forwardRef(function FadeTransition(props: FadeTransitionProps, ref) {
  const { children, ...other } = props;
  return (
    <Fade {...other} ref={ref} timeout={{ enter: TRANSITION_TIMEOUT, exit: 0 }} appear>
      {children}
    </Fade>
  );
});

export const ScrollingDialog = ({ children, scroll, ...props }: ScrollingDialogProps) => {
  return (
    <MuiDialog
      {...props}
      scroll={scroll}
      closeAfterTransition
      slots={{ backdrop: Backdrop, transition: FadeTransition }}
      slotProps={{
        backdrop: {
          timeout: { enter: TRANSITION_TIMEOUT, exit: 0 },
          style: { backgroundColor: "#1A192DCC" },
        },
      }}
    >
      <div className="supportsRtl">{children}</div>
    </MuiDialog>
  );
};
